import { styled } from "@stitches/react";
import { ReactNode } from "react";

const DalmaInfoWrapper = styled("div", {
  padding: 16,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  border: "1px solid #DBEBFF",
  background: "#FFFFFF",
  borderRadius: "8px",
  boxSizing: "border-box",
  fontSize: 12,

  variants: {
    column: {
      true: {
        flexDirection: "column",
        alignItems: "flex-start",

        "&>:first-child": {
          marginBottom: "10px",
        },
      },
      false: {
        "&>:first-child": {
          marginRight: "10px",
        },
      },
    },
  },
});

export function DalmaInfo({
  children,
  column = false,
  error = false,
}: {
  children: ReactNode;
  column?: boolean;
  error?: boolean;
}) {
  return (
    <DalmaInfoWrapper column={column}>
      {error ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="#e6787a"
          style={{ flex: "none" }}
          viewBox="0 0 24 24"
        >
          <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.31 7.526c-.099-.807.528-1.526 1.348-1.526.771 0 1.377.676 1.28 1.451l-.757 6.053c-.035.283-.276.496-.561.496s-.526-.213-.562-.496l-.748-5.978zm1.31 10.724c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="#688AB8"
          style={{ flex: "none" }}
          viewBox="0 0 24 24"
        >
          <path d="M17.09 2.82a8 8 0 00-6.68-1.66 8 8 0 00-6.27 6.32 8.07 8.07 0 001.72 6.65A4.54 4.54 0 017 17v3a3 3 0 003 3h4a3 3 0 003-3v-2.81A5.17 5.17 0 0118.22 14a8 8 0 00-1.13-11.2v.02zM15 20a1 1 0 01-1 1h-4a1 1 0 01-1-1v-1h6v1zm1.67-7.24A7.13 7.13 0 0015 17h-2v-3a1 1 0 00-2 0v3H9a6.5 6.5 0 00-1.6-4.16 6 6 0 013.39-9.72A6 6 0 0118 9a5.89 5.89 0 01-1.33 3.76z" />
        </svg>
      )}
      <span style={{ color: "#424242" }}>{children}</span>
    </DalmaInfoWrapper>
  );
}
